import { BaseDto } from '../base.dto';
import { CashupConfigurationTypeEnum } from '../config-cash-up';
import { DeliveryPartnersConfigurationTypeEnum } from '../config-delivery-partners';
import { GiftCardConfigurationTypeEnum } from '../config-gift-card';
import { KioskConfigurationTypeEnum } from '../config-kiosk';
import { OnlineOrderingConfigurationTypeEnum } from '../config-online-ordering';
import { PosConfigurationTypeEnum } from '../config-pos';
import { PurchasingConfigurationTypeEnum } from '../config-purchasing';
import { ReputationManagementConfigurationTypeEnum } from "../config-reputation-management";
import { StockManagementConfigurationTypeEnum } from '../config-stock-management';
import { ConfigurationDataTypeDto } from '../configurationDataType.dto';
import { BoiCollectConfigurationTypeEnum } from '../config-boi-collect';

export class ConfigurationDto extends BaseDto {
  name:
    | PosConfigurationTypeEnum
    | KioskConfigurationTypeEnum
    | CashupConfigurationTypeEnum
    | GiftCardConfigurationTypeEnum
    | OnlineOrderingConfigurationTypeEnum
    | PurchasingConfigurationTypeEnum
    | DeliveryPartnersConfigurationTypeEnum
    | ReputationManagementConfigurationTypeEnum
    | StockManagementConfigurationTypeEnum
    | BoiCollectConfigurationTypeEnum;
  description?: string;
  dataType?: ConfigurationDataTypeDto;
  value?: string;
}
